import React from "react";

const FormProgress = ({ currentStep, totalSteps, setCurrentStep, config }) => {
	const formConfig = config?.config;
	const fields = formConfig?.steps;

	// filter out steps that should not be shown in the progress bar (Thank you step)
	const visibleSteps = fields
		.map((step, actualIndex) => ({ step, actualIndex }))
		.filter(({ step }) => !step?.remove_from_progress);

	return (
		<div className="form-progress">
			<div className="progress-steps">
				{visibleSteps.map((step, index) => (
					<div
						key={index}
						className={`progress-step ${
							index === currentStep ? "active" : ""
						} ${index < currentStep ? "completed" : ""}`}
						onClick={() => {
							if (window.location.href.includes("localhost") || window.location.href.includes(".build")) {
								setCurrentStep(index); //useful for debugging
							}
						}}
					>
						<div className="step-details">
							<div className="step-number">{index + 1}</div>
							{fields[index]?.short_title && (
								<div className="step-title">{fields[index].short_title}</div>
							)}
						</div>
					</div>
				))}
			</div>
		</div>
	);
};

export default FormProgress;
